<template>
  <div class="flex between flexy gui-container" style="overflow: hidden;">
    <div class="navbar flex ">
      <div class="flex align-center flexy">
        <i v-if="$store.state.debug" class="fas fa-bug p8" @click="$store.commit('log', {title:'App State', value: $store.state})"></i>
        <router-link class="flex center r8" to="/" >
            <img style="max-width: 100px; object-fit: contain;" class="header-image flex center" :src="$store.state.app.basics.logo || '/img/stock/logo.svg'" :alt="$store.state.app['app name'] || 'xmbl'">
        </router-link>
        <div class="flex wrap flexy">
          <div style="white-space: nowrap" v-if="$store.state.windowWidth >= 640" class="flex align-center r16">
            <b :class="($store.state.windowWidth > 540) ? 'xl-font' : $store.state.app.basics['app name'].length < 12 ? 'lg-font' : $store.state.app.basics['app name'].length < 16 ? 'md-font' : 'sm-font'" class="">{{$store.state.app.basics['app name'].substring(0, 20) || 'New App...'}}</b>
          </div>
          <div class="flex around flexy align-center">
            <span class="r16" :key="link[0]" v-for="link in moduleLinks" @click="$store.state.show[link[0]] ? closeAll() : (closeAll(), link[4]())">
              <div v-if="(link[0] === 'cart' && $store.state.anon.cart) || (link[3] === 'fn' && $store.state.auth.uid && $store.state.app.basics.modules && $store.state.app.basics.modules.indexOf(link[0]) > -1)" class="flex align-center">
                <span v-if="$store.state.counts[link[0]] && $store.state.counts[link[0]] > 0" class="" style="height: 0; width: 0; overflow: visible; position: absolute;">
                  <b class="nav-counts">{{$store.state.counts[link[0]]}}</b>
                </span> 
                <i :class="link[2]"></i>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="flex align-center">
        <div class="flex wrap align-center" v-if="($store.state.app.basics.items ? $store.state.windowWidth > (JSON.stringify($store.state.app.itemTypes).length * 30) : true) && $store.state.windowWidth > 480">
          <div :key="typeKey" v-for="(type, typeKey) in ($store.state.app.basics.items || [])" class="flex center r8" style="position: relative;">
            <div v-if="$store.state.app.basics.items" class="flex align-center sm-font" @click="closeAll();">
              <router-link :to="`/list/${type.name}`" style="z-index: 1;" :class="(($store.state.windowWidth <= 480 && JSON.stringify($store.state.app.itemTypes).length <= 12)) ? 'sm-font' : ($store.state.windowWidth <= 480 && JSON.stringify($store.state.app.itemTypes).length > 12) ? 'xs-font' : ''" class="r4">
                <b class="flex align-center"><i :class="`${type.icon || 'fa fa-circle'} `" class="r4"></i><span>{{type.name.toUpperCase()}}</span></b>
              </router-link>
              <!-- <router-link v-if="$store.state.auth.uid && ($store.state.app.user.indexOf(($store.state.auth.uid) > -1) || type['crowd allowed'])" :to="`/new/${type.name}`" class="flex align-center sm-font r4" style="z-index:999999" >
                <i class="fas fa-plus-square"></i>
              </router-link> -->
            </div>
          </div>
          <div @click="$store.state.show.pages ? closeAll() : (closeAll(), $set($store.state.show, 'pages', !$store.state.show.pages))" class="sm-font r8 "><i class="fas fa-caret-down r4"></i>Pages</div>
          <transition name="drop">
            <div class="container around fit module-popdown" v-if="$store.state.show.pages" style="">
              <div class="sub-container">
                <h5 class="r16">Pages</h5>
                <div @click="closeAll()" class="flex column align-start" :key="pageKey" v-for="(page, pageKey) in $store.state.app.pages">
                  <router-link v-if="page" class="p4 sm-font" :to="`/page/${pageKey}`" ><i :class="$store.state.icons[pageKey] || 'fas fa-file-alt'" class="r4 fa-sm"></i>{{pageKey.toUpperCase()}}</router-link>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div v-else class="r8">
          <i style="cursor: context-menu" class="fas fa-bars" @click="!$store.state.show.items ? (closeAll(), $set($store.state.show, 'items', !$store.state.show.items)) : closeAll()"></i>
          <transition name="drop">
            <div v-if="$store.state.show.items"  class="flex wrap sub-container column" style="position: absolute; top: 48px; right: 0;">
              <div :key="typeKey" v-for="(type, typeKey) in ($store.state.app.basics.items || [])" class="flex " style="position: relative; border-bottom: 1px solid rgba(0,0,0,.05);">
                <div v-if="$store.state.app.basics.items" class="flex align-center between flexy" @click="closeAll();">
                  <router-link :to="`/list/${type.name}`" style="z-index: 1;" :class="(($store.state.windowWidth <= 480 && $store.state.app.basics.items.length <= 2)) ? 'sm-font' : ($store.state.windowWidth <= 480 && $store.state.app.basics.items.length > 2) ? 'xs-font' : ''" class="p4 flexy flex between align-center">
                    <span class="flex align-center"><i :class="`${type.icon || 'fa fa-circle fa-sm'} ${$store.state.windowWidth > 480 ? 'fa-lg' : ''}`" class="r4"></i><span>{{type.name.toUpperCase()}}</span></span><i class="fas fa-chevron-right"></i>
                  </router-link>
                  <!-- <router-link @click="closeAll()" v-if="$store.state.auth.uid && ($store.state.app.user.indexOf(($store.state.auth.uid) > -1) || type['crowd allowed'])" :to="`/new/${type.name}`" class="flex align-center sm-font p4" style="z-index:999999" >
                    <i class="fas fa-plus"></i>
                  </router-link> -->
                </div>
              </div>
              <div class="flex around xs-font align-center">
                <b class="r8">Pages</b>
                <div :key="pageKey" v-for="(page, pageKey) in $store.state.app.pages" @click="closeAll()" class="flex wrap">
                  <router-link v-if="page" class=" xs-font" :to="`/page/${pageKey}`"><i :class="$store.state.icons[pageKey.toLowerCase()] || 'fas fa-file-alt'" class="r4 fa-sm p4 flexy"></i>{{pageKey.toUpperCase()}}</router-link>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="flex around align-center" :style="`height: ${$store.state.device.mobile ? 56 : 64}px; position: fixed; right: ${$store.state.device.mobile ? 2 : 8}px; top: 0px`">
      <span 
        class="p8"
        :key="link[0]" 
        v-for="link in comLinks" 
        @click="$store.state.show[link[0]] ? closeAll() : (closeAll(), link[4]())">
        <div style="margin: 0; width: 20px" 
        class="flex align-center center" 
        v-if="(link[3] === 'fn' && $store.state.auth.uid && $store.state.app.basics.modules && ($store.state.app.basics.modules.indexOf(link[0]) > -1 || $store.state.modules.indexOf(link[0]) === -1))">
          <span v-if="$store.state.counts[link[0]] && $store.state.counts[link[0]] > 0" style="height: 0; width: 0; overflow: visible; position: absolute;">
            <b :style="`background-color: ${$store.state.app.style.color};`" :class="`${link[7]}-text com-counts`">{{$store.state.counts[link[0]]}}</b>
          </span>
          <i 
            :style="`text-shadow: ${$store.state.app.style.container} 0px 0px 2px, ${$store.state.app.style.container} 0px 0px 4px`"
            class="fas" 
            :class="`${link[6][$store.state.counts[link[0]] && $store.state.counts[link[0]] > 0 ? 1 : 0]} ${(link[2])} ${link[7]}-text`"></i>
        </div>
      </span>
      <span @mouseover="show.profile = true" @mouseleave="show.profile = false" v-if="$store.state.auth.uid" class="flex around align-center p8" @click="$store.state.show.profile ? $store.commit('closeAll') : ($store.commit('closeAll'), $set($store.state.show, 'profile', true))">
      <user :userid="$store.state.auth.uid" nolink="true" image-only="true"/>
      <!-- :image-only="show.profile ? false : true" -->
    </span>
    <span v-else> 
      <div class="flex around align-center p8">
      <a href @mouseover="show.reveal = true" @mouseleave="show.reveal = false" @click.prevent="$store.state.auth.uid ? $store.dispatch('auth', {type: 'logout'}) : null; $set($store.state.show, 'auth', !$store.state.show.auth)"><i class="r4" :class="$store.state.auth.uid ? 'fas fa-sign-out-alt' : 'fas fa-sign-in-alt'"></i>{{$store.state.auth.uid ? 'Exit' : 'Enter'}}</a> 
      <!-- show.reveal ? $store.state.auth.uid ? 'Exit' : 'Enter' : null -->
    </div>
    </span>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['vertical', 'left', 'right', ],
    data () {
      return {
        moduleLinks: [ // []
          ['cart', 'cart', 'fas fa-shopping-cart', 'fn', () => {
            this.$set(this.$store.state.show, 'cart', !this.$store.state.show.cart)
          }, 'auth'],
          ['jobs', 'jobs', 'fas fa-briefcase', 'fn', () => {
            this.$set(this.$store.state.show, 'jobs', !this.$store.state.show.jobs)
          }, 'auth'],
          ['events', 'events', 'fas fa-calendar', 'fn', () => {
            this.$set(this.$store.state.show, 'events', !this.$store.state.show.events)
          }, 'auth']
        ],
        comLinks: [
          ['messages', '', ' fa-envelope', 'fn', () => {
            this.$set(this.$store.state.show, 'messages', !this.$store.state.show.messages)
          }, 'auth', ['far', 'fas'], 'update'],
          ['notifications', '', ' fa-bell', 'fn', () => {
            this.$set(this.$store.state.show, 'notifications', !this.$store.state.show.notifications)
          }, 'any', ['far', 'fas'], 'indicate']
        ],
        show:{}
      }
    },
    created () {
      this.$store.state.anon.cart = JSON.parse(localStorage.getItem('cart'))
    },
    methods: {
      closeAll () {
        this.$set(this.$store.state.componentKeys, 'navigation', 0)
        this.$set(this.$store.state, 'pointer', {})
        this.$store.commit('closeAll')
      }
    }
  }
</script>